import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import contact from '../../../js/stores/contact.js';
import language from '../../../js/stores/language.js';
import carLoan from '../../../js/stores/car-loan.js';
import file from '../../../js/stores/file.js';
import UserSignArea from './user-sign-area.f7.html';
var DecidingTab = function DecidingTab(props, _ref) {
  var $h = _ref.$h,
    $f7 = _ref.$f7,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var data = props.data;
  var borrowerData = {};
  var locale = language.getters.Item.value;
  var canvas = null;
  var extraSetup = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var result;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return contact.dispatch('getContactData', data.CarLoanData.BorrowerId);
          case 1:
            result = _context.sent;
            if (result.status !== undefined && result.status !== 200) {
              console.log(result.data.messages.error);
            }
            borrowerData = result;
            $update();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function extraSetup() {
      return _ref2.apply(this, arguments);
    };
  }();
  var verifyImage = function verifyImage(value) {
    canvas = value.detail;
  };
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          setTimeout(function () {
            extraSetup();
          }, 500);
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })));
  var cancelDeciding = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            $f7.dialog.confirm(locale.translate('loan.deciding.confirmCancel'), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              var form, result;
              return _regeneratorRuntime.wrap(function (_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 1;
                    return getFormData();
                  case 1:
                    form = _context3.sent;
                    _context3.next = 2;
                    return carLoan.dispatch('lenderCancels', form);
                  case 2:
                    result = _context3.sent;
                    if (!(result.status !== undefined && result.status !== 200)) {
                      _context3.next = 3;
                      break;
                    }
                    $f7.toast.show({
                      text: result.data.messages.error
                    });
                    return _context3.abrupt("return");
                  case 3:
                    $f7.toast.show({
                      text: locale.translate('loan.deciding.messageCancel')
                    });
                    $f7.views.main.router.navigate('/', {
                      reloadCurrent: true,
                      ignoreCache: true
                    });
                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            })));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function cancelDeciding() {
      return _ref4.apply(this, arguments);
    };
  }();
  var saveDeciding = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (document.getElementById('lender-acceptance-agreement').checked) {
              _context6.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('user.newAccount.userAcceptAgreementMessage')
            });
            document.getElementById('borrower-acceptance-agreement').focus();
            return _context6.abrupt("return");
          case 1:
            if (!(canvas == null)) {
              _context6.next = 2;
              break;
            }
            $f7.toast.show({
              text: locale.translate('loan.signImage.noSignMessage')
            });
            return _context6.abrupt("return");
          case 2:
            $f7.dialog.confirm(locale.translate('loan.deciding.confirmAccept'), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
              var form, result, dataURL, signData, saveSign;
              return _regeneratorRuntime.wrap(function (_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 1;
                    return getFormData();
                  case 1:
                    form = _context5.sent;
                    _context5.next = 2;
                    return carLoan.dispatch('lenderAccepts', form);
                  case 2:
                    result = _context5.sent;
                    if (!(result.status !== undefined && result.status !== 200)) {
                      _context5.next = 3;
                      break;
                    }
                    $f7.toast.show({
                      text: result.data.messages.error
                    });
                    return _context5.abrupt("return");
                  case 3:
                    dataURL = canvas;
                    signData = {
                      referenceId: data.CarLoanData.CarLoanId,
                      image: dataURL
                    };
                    _context5.next = 4;
                    return file.dispatch('saveLenderSignImage', signData);
                  case 4:
                    saveSign = _context5.sent;
                    if (!(saveSign.status !== undefined && saveSign.status !== 201)) {
                      _context5.next = 5;
                      break;
                    }
                    $f7.toast.show({
                      text: saveSign.data.messages.error
                    });
                    return _context5.abrupt("return");
                  case 5:
                    $f7.toast.show({
                      text: locale.translate('loan.deciding.messageAccept')
                    });
                    $f7.views.main.router.navigate('/', {
                      reloadCurrent: true,
                      ignoreCache: true
                    });
                  case 6:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5);
            })));
          case 3:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function saveDeciding() {
      return _ref6.apply(this, arguments);
    };
  }();
  var getFormData = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var formData;
      return _regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            formData = new FormData();
            formData.append("CarLoanId", data.CarLoanData.CarLoanId);
            formData.append("CarId", data.CarMainData.CarId);
            formData.append("LenderId", data.CarMainData.ContactId);
            formData.append("BorrowerId", data.CarLoanData.BorrowerId);
            return _context7.abrupt("return", formData);
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function getFormData() {
      return _ref8.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page-content tab" id="tab-2-deciding">
  <div class="block">
    <form id="deciding-form" class="list no-hairlines-md">
      <ul>
        <li>
          <label class="item-checkbox item-content item-checkbox-icon-end">
            <input id="lender-acceptance-agreement" name="LenderAcceptanceAgreement" type="checkbox" />
            <i class="icon icon-checkbox"></i>
            <div class="item-inner">
              <div class="item-title">${locale.translate('user.newAccount.userAgreementCheckbox')}</div>
              <a href="/static/docs/DeLeenAuto-Agreement.pdf" class="external link color-red" target="_system">[${locale.translate('user.newAccount.userAgreementViewDoc')}]</a>
            </div>
          </label>
        </li>
      </ul>
      <${UserSignArea} @checkSignedImage=${verifyImage} user-first-name=${data.CarMainData.ContactName} user-last-name=${data.CarMainData.ContactFirstLastName} prefix-area='lender' />
      <p>
        <h4>${borrowerData.ContactName} ${borrowerData.ContactFirstLastName}  ${locale.translate('loan.deciding.hasDecided')}</h4>
        <h3>${locale.translate('loan.deciding.loanInfo')}: </h3>
        <ul>
          <li>${locale.translate('general.from')} ${data.CarLoanData.CarLoanStartDate} ${locale.translate('general.to')} ${data.CarLoanData.CarLoanEndDate}</li>
          <li>${locale.translate('loan.deciding.yourEarnings')}: €${data.CarLoanData.TotalToPay}</li>
          <li>
            ${locale.translate('loan.dashboard.isGoingAbroad')} ${data.CarLoanData.IsGoingAbroad > 0 ?
            $h`<i class="icon material-symbols-outlined color-green">done</i>`
            :
            $h`<i class="icon material-symbols-outlined color-red">close</i>
            `}
          </li>
          <li>
            ${locale.translate('loan.request.onlyDriver')} ${data.ExtraDriverData.ContactId < 1 ?
            $h`<i class="icon material-symbols-outlined color-green">done</i>`
            :
            $h`<i class="icon material-symbols-outlined color-red">close</i>
            `}
          </li>
          ${data.ExtraDriverData.ContactId > 0 ? $h`
          <li>Extra driver data:</li>
          ` : 
          $h``}
        </ul>
      </p>
    </form>
    ${props.data.CarLoanData.CarLoanStatusId == 1 && $h`
    <div class="block block-strong">
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div>
          <a href="#" class="button button-small button-fill button-raised color-red" @click="${cancelDeciding}">
            <span class="material-symbols-outlined">close</span>${locale.translate('general.decline')}
          </a>
        </div>
        <div></div>
        <div>
          <a href="#" class="button button-small button-fill button-raised color-green" @click="${saveDeciding}">
            <span class="material-symbols-outlined">done</span>${locale.translate('general.accept')}
          </a>
        </div>
      </p>
    </div>
    `}
  </div>
</div>
`
    }
    ;
};
export default DecidingTab;